import React from 'react';
import Button from 'components/Button';
import * as Styled from './styles';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <Styled.ModalOverlay>
      <Styled.ModalContainer>
        <Styled.ModalTitle>{title}</Styled.ModalTitle>
        <Styled.ModalMessage>{message}</Styled.ModalMessage>
        <Styled.ButtonContainer>
          <Button
            id="cancel-new-consultation-modal-button"
            onClick={onCancel}
            buttonText={cancelText}
            icon={null}
            iconPosition="left"
            state="secondary"
            disabled={false}
          />
          <Button
            id="confirm-new-consultation-modal-button"
            onClick={onConfirm}
            buttonText={confirmText}
            icon={null}
            iconPosition="left"
            state="primary"
            disabled={false}
          />
        </Styled.ButtonContainer>
      </Styled.ModalContainer>
    </Styled.ModalOverlay>
  );
};

export default ConfirmationModal;
